import {ConfigObjectType, HierarchyMetadata, useCurrentLocale} from '@wallaby-ui/core';
import React, {useMemo} from 'react';

import {HierarchyFilterProps, LightHierarchyFilter} from './LightHierarchyFilter';
import {WallabyCoreSchema} from '../../types';
import {useMedicationAtcs} from 'src/js/containers/medications';

type MedicationAtc = WallabyCoreSchema.components['schemas']['AtcHierarchyNodeWithParentDto'] & HierarchyMetadata;
export type LightMedicationAtcFilter2Props = Omit<HierarchyFilterProps<MedicationAtc>, 'options'> & {
  appConfig: ConfigObjectType;
};
export const LightMedicationAtcFilter2: React.FC<LightMedicationAtcFilter2Props> = (props) => {
  const {appConfig, ...extraProps} = props;
  const {data: options, isLoading: _} = useMedicationAtcs<MedicationAtc>(appConfig);

  const currentLocale = useCurrentLocale();

  const sortedOptions = useMemo(() => {
    const collator = new Intl.Collator(currentLocale, {
      sensitivity: 'base',
      usage: 'sort',
      numeric: false,
    });
    return options?.slice().sort((a, b) => collator.compare(a.label, b.label));
  }, [options, currentLocale]);

  return <LightHierarchyFilter {...extraProps} options={sortedOptions} ignoreOption={(option) => option.original.isSoloRootNode} />;
};
